import {
  cilBan,
  cilCheck,
  cilInbox,
  cilLockLocked,
  cilPen,
  cilPencil,
  cilPlus,
  cilScrubber,
  cilTrash,
  cilUser,
} from "@coreui/icons";

const Assets: any = {
  email: cilInbox,
  username: cilUser,
  password: cilLockLocked,
  text: cilPen,
  on_going: cilCheck,
  edit: cilPencil,
  delete: cilTrash,
  view: cilScrubber,
  ban: cilBan,
  not_joined: cilBan,
  activate: cilCheck,
  done: cilCheck,
  joined: cilCheck,
  plus: cilPlus,
  not_done: cilBan,
};

export default Assets;
